import React from 'react';
import styled from '@emotion/styled';
import { useIntl, FormattedMessage } from 'gatsby-plugin-intl';

import { DonatePattern } from '../../svgs/DonatePattern';
import { Eye } from '../../svgs/Eye';
import BGPattern from '../../images/donate-pattern.png';

const ImageWrapper = styled.div`
  /* background: none;
  @media (max-width: 767px) { */
  background: url(${BGPattern}) repeat;
  /* } */
`;

export const Donations = () => {
  const { formatMessage, locale } = useIntl();

  return (
    <section className="w-full py-12 md:py-24 lg:pt-96 flex flex-col items-center">
      <h2 className="xl:container mx-auto px-4 sm:px-6 lg:px-8 text-2xl md:text-4xl lg:text-6xl font-heading font-bold mb-4 md:mb-6 lg:mb-16 md:text-center">
        {formatMessage({ id: 'donations.title' })}
      </h2>
      <ImageWrapper className="w-full h-64 md:h-96 relative">
        {/* <DonatePattern className="hidden md:block h-128 xl:h-auto xl:w-full" /> */}
        <div className="absolute w-full h-full top-0 left-0 right-0 xl:container mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
          <Eye className="w-32 md:w-64 lg:w-84 mr-8 md:mr-12 lg:mr-16" />
          <div className="p-4 flex flex-col items-end bg-white font-bold">
            <div className="font-heading text-3xl md:text-5xl">
              {Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(256777)}
            </div>
            <div>{formatMessage({ id: 'donations.amountDonated' })}</div>
          </div>
        </div>
      </ImageWrapper>
    </section>
  );
};
